// Read more: https://kit.svelte.dev/docs/load
import { PREVIEW_MODE } from '$lib/global/constants';

import { themeBorderRadius, embedOptions, advancedLinking } from '$lib/Stores/stores';
import { appendDomainQueryParam } from '$lib/utils/appendDomainQueryParam';
import { getDataBaseUrl } from '$lib/utils/getDataBaseUrl';
import { loadFontsAsync } from '$lib/utils/previewUtils';

import debug from 'debug';

import type { LayoutData } from '$lib/types/LayoutData';
import type { PageLoad } from './$types';

export const prerender = false;
export const ssr = false;
export const trailingSlash = 'always';

const debugLog = debug('routes:+layout.js');

export const load: PageLoad = async ({ fetch }) => {
    const dataBasePath = getDataBaseUrl();
    const res = await fetch(
        `${dataBasePath}/layoutData.json?v=${window.campaignVersionId}${appendDomainQueryParam()}`,
    );
    const layoutData: LayoutData = await res.json();

    // Populate stores
    themeBorderRadius.set(layoutData.theme.borderRadius);
    advancedLinking.set(layoutData.advancedLinkingLogic);

    const urlParams = new URLSearchParams(window.location.search);

    embedOptions.set({
        isEmbed: urlParams.get('embed') === '1',
        // if preview is true, we don't send analytics data
        preview: PREVIEW_MODE ? true : urlParams.get('preview') === '1',
        header: urlParams.get('header') !== '0',
        footer: urlParams.get('footer') !== '0',
        autoHeight: urlParams.get('autoHeight') === '1',
        cookieBanner: urlParams.get('cookieBanner') !== '0',
    });

    debugLog(layoutData);

    // for custom fonts
    if (PREVIEW_MODE && layoutData.theme.fontId) {
        const fontName = layoutData.theme.fontId;
        await loadFontsAsync(
            `https://assets.perspective.co/ps-assets/${layoutData.companyId}/fonts/${fontName}.css`,
        );

        try {
            let customFonts: FontFace[] = [];

            document.fonts.ready.then((fontFaceSet) => {
                const fontFaces = [...fontFaceSet];
                customFonts = fontFaces.filter((font) => font.family === fontName);
            });

            await Promise.all(customFonts.map((font) => font.load()));
        } catch (error) {
            console.error('Custom Font failed to load', error);
        }
    }

    return layoutData;
};
